// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


require("@rails/ujs").start()

global.$ = require('jquery')
global.jQuery = global.$
window.jQuery = global.$

require('popper.js')

require("turbolinks").start()
require("@rails/activestorage").start()

// CSP nonces are generated per request. Turbolinks XHR-loads new pages whose
// inline <script nonce="..."> tags carry a fresh nonce, but the browser still
// enforces the ORIGINAL page's CSP header (which only knows the original
// nonce — HTTP headers can't be retroactively changed by XHR responses).
// Turbolinks also merges the new <meta name="csp-nonce"> into the live head,
// so by render time the meta no longer reflects the original. We capture the
// initial nonce at pack load and rewrite every incoming inline script to use
// it. Without this, body scripts like notifierDict get CSP-blocked on every
// Turbolinks navigation until a full reload.
const initialCspNonce = document.querySelector('meta[name="csp-nonce"]')?.content
document.addEventListener('turbolinks:before-render', (event) => {
  if (!initialCspNonce) return
  event.data.newBody.querySelectorAll('script[nonce]').forEach((script) => {
    script.setAttribute('nonce', initialCspNonce)
  })
})
require("channels")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
